import React, { useEffect, useMemo, useState } from "react";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import { fetchDailyFortune } from "../../../service/FortuneWidgetService";
import "./FortuneTeller.scss";
import FortuneIcon from "/resources/icons/WidgetToolbar/Fortune-ToolbarWidget-Icon.svg";

export default function FortuneTeller() {
    const { user }: UserContextType = useUserContext();

    const [fortuneText, setFortuneText] = useState<string>("");

    useEffect(() => {
        if (user && user.emailVerified) {
            fetchDailyFortune((fortuneStr: string) => setFortuneText('"' + fortuneStr + '"'));
        }
    }, [user]);

    return (
        <div className={`fortune-widget-content`}>
            <h3 className={`fortune-text`}>{fortuneText}</h3>
        </div>
    );
}

const FORTUNE_WIDGET_HEADER_LABEL = "Daily Fortune";
export function FortuneTellerHeader() {
    const currDate = useMemo(() => getFormattedDate(), []);

    return (
        <div className={`fortune-teller-header`}>
            <FortuneIcon className={"fortune-teller-icon"} />

            <span className={`fortune-widget-header-text`}>
                {FORTUNE_WIDGET_HEADER_LABEL} | {currDate}
            </span>
        </div>
    );
}

const getFormattedDate = () => {
    return new Date().toLocaleDateString();
};
